import styled from 'styled-components';
import React, {useEffect, useRef} from 'react';
import useWindowDimensions from "../utils/dimensions";

const VideoPlayer = styled(({ className, src }) => {

    const {width: windowWidth, height: windowHeight} = useWindowDimensions();
    const adjustedWindowWidth = windowWidth - 32;

    const containerWidth = adjustedWindowWidth > 900 ? 640 : adjustedWindowWidth;
    const containerHeight = adjustedWindowWidth > 900 ? 480 : adjustedWindowWidth;

    const iframeRef = useRef(null);

    useEffect(() => {
        const observer = new IntersectionObserver(
            (entries) => {
                entries.forEach((entry) => {
                    if (iframeRef.current) {
                        if (!entry.isIntersecting) {
                            iframeRef.current.contentWindow.postMessage('pause', '*');
                        }
                    }
                });
            },
            {
                threshold: 0.5,
            }
        );

        if (iframeRef.current) {
            observer.observe(iframeRef.current);
        }

        return () => {
            if (iframeRef.current) {
                observer.unobserve(iframeRef.current);
            }
        };
    }, []);

    return (
        <div className={className} style={{ margin: '0 auto', marginTop: '8px', borderRadius: '12px', position: 'relative', width: containerWidth, height: containerHeight, maxWidth: '100%', backgroundColor: '#000' }}>
            <iframe allowfullscreen ref={iframeRef} allow="fullscreen" style={{width: "100%", height: "100%", borderRadius: '12px'}} src={`https://player.scored.co?url=${src}`} />
        </div>
    )})``;

export default VideoPlayer;